var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-notifications',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var notification = ref.notification;
return [_c('v-alert',{attrs:{"type":notification.type,"dense":"","prominent":""}},[_vm._v(" "+_vm._s(notification.text)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }